module.exports = __webpack_public_path__ + "static/media/landing_bg_mobile.a15572ad.png";